export default "__VITE_ASSET__8737e135__"